import * as DATASET_ACTION from 'constant/action/dataset'
import { handleActions } from 'redux-actions'

const initialState = {
  articleDescription: '',
  datasets: {},
  pagination: {},
  searchTerm: ''
}

export default handleActions(
  {
    [DATASET_ACTION.UPDATE_DATASETS]: (state, action) => ({
      ...state,
      datasets: action.payload
    }),
    [DATASET_ACTION.UPDATE_DATASET_PAGINATION]: (state, action) => ({
      ...state,
      pagination: action.payload
    }),
    [DATASET_ACTION.UPDATE_DATASET_SEARCH_TERM]: (state, action) => ({
      ...state,
      searchTerm: action.payload
    }),
    [DATASET_ACTION.UPDATE_DATASET_DESCRIPTION]: (state, action) => ({
      ...state,
      articleDescription: action.payload
    })
  },
  initialState
)
